import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookMarkIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.0005 25.6648H28.0005M28.0005 25.6648H35.0005M28.0005 25.6648V18.6648M28.0005 25.6648V32.6648M46.6671 51.3315V23.3315C46.6671 16.7976 46.6671 13.5306 45.3955 11.035C44.2771 8.83973 42.4923 7.05494 40.2971 5.93644C37.8014 4.66484 34.5345 4.66484 28.0005 4.66484C21.4665 4.66484 18.1996 4.66484 15.7039 5.93644C13.5087 7.05494 11.7239 8.83973 10.6054 11.035C9.3338 13.5306 9.3338 16.7976 9.3338 23.3315V51.3315L14.6437 48.6766C19.5412 46.2278 21.9899 45.0035 24.5583 44.5217C26.8333 44.0947 29.1676 44.0947 31.4426 44.5217C34.0111 45.0035 36.4597 46.2278 41.3572 48.6766L46.6671 51.3315Z",
		stroke: "#BAB9C0",
		strokeWidth: 3.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBookMarkIcon;
